module.exports = __webpack_public_path__ + "img/img34.c0b5ef76.svg";